module.exports = __webpack_public_path__ + "static/media/admin_arrow.37885c9f.svg";